import React from 'react';
import Hero from '../components/Hero';
import AffiliationLogoRow from '../components/AffiliationLogoRow';

const Home = () => {
  return (
    <div>
      <Hero />
      <AffiliationLogoRow />
    </div>
  );
};

export default Home;

